const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToolNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.9374mm",
    height: "7.9374mm",
    viewBox: "0 0 7.9374 7.9374",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-105.23 -138.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-327.11 61.618)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.33,
    y: 76.828,
    width: 7.9374,
    height: 7.9374,
    rx: 0.93255,
    ry: 0.93255,
    style: {
      fillRule: "evenodd",
      fill: "#ffffff",
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.84161 0 0 .84161 57.416 12.919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m446.22 76.683h1.9118v7.9375h-1.9118z",
    style: {
      fill: "#7fb536",
      paintOrder: "stroke markers fill",
      strokeDashoffset: 11.411,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.59592
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.77 76.683v7.9374h5.3837l-5.3837-7.9374zm2.24 5.3174a.88549.88549 0 01.88541.88542.88549.88549 0 01-.88541.88542.88549.88549 0 01-.88542-.88542.88549.88549 0 01.88542-.88542z",
    style: {
      fill: "#4b8ec4",
      paintOrder: "stroke markers fill",
      strokeDashoffset: 11.411,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.54796
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.8 80.686h.55024",
    style: {
      fill: "none",
      strokeWidth: 0.26458,
      stroke: "#164d7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.8 81.696h.55024",
    style: {
      fill: "none",
      strokeWidth: 0.26458,
      stroke: "#164d7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.8 82.707h.55024",
    style: {
      fill: "none",
      strokeWidth: 0.26458,
      stroke: "#164d7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.22 80.686h.55024",
    style: {
      fill: "none",
      strokeWidth: 0.26458,
      stroke: "#164d7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.22 81.696h.55024",
    style: {
      fill: "none",
      strokeWidth: 0.26458,
      stroke: "#164d7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.22 82.707h.55024",
    style: {
      fill: "none",
      strokeWidth: 0.26458,
      stroke: "#164d7c"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolNew);
export default __webpack_public_path__ + "static/media/icon_tool_new.f8717201a2d2c06a21cf13b153d503f7.svg";
export { ForwardRef as ReactComponent };